/* eslint-disable operator-linebreak */
/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useMemo, useRef, useState, forwardRef } from 'react';
import { Box, CardContent, Grid, Dialog, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { green } from '@mui/material/colors';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import Remittance from 'pages/purchase/components/Remittance';
import Bill from 'components/Bill';
import SingleButton from 'components/Buttons/ButtonGroup/SingleButton';
import api from 'services/api';
import { isValidDate } from 'utils';
import Input from 'pages/purchase/components/Input';
import SimpleBackdrop from 'components/Progress';

import * as S from './styles';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export default function ModalShipment({ open, handleClose, fetchLots }) {
  const {
    location: { state },
    classes,
    id,
    loadingRequest,
    success,
    error,
    requestCompleted,
  } = useDependencyInjection();

  const identificationComponentRef = useRef(null);
  const billComponentRef = useRef(null);

  const identificationRef = useRef(null);
  const billRef = useRef(null);

  const dataLocation = state?.data || state?.customData;

  const isInput =
    state?.productType === 'input' || dataLocation?.items?.length > 0;

  const [totalPrice, setTotalPrice] = useState(0);
  const [loading, setLoading] = useState(true);

  const handleUpdateTotalPrice = (value) => {
    setTotalPrice(value);
  };

  const callbackFunctionIdentification = (payload) => {
    identificationRef.current = payload;
  };

  const callbackFunctionBill = (payload) => {
    billRef.current = payload;
  };

  const formsValid = () =>
    identificationRef.current.isValid && billRef.current.isValid;

  const getValues = (ref) => ref.current?.values;

  const type = 'pagamento';

  const postRequestPurchases = async (data) => {
    try {
      setLoading(true);
      loadingRequest();
      await api.post('/purchases', data);
      success();
      fetchLots();
      handleClose();
    } catch (err) {
      error();
    } finally {
      requestCompleted();
      setLoading(false);
    }
  };

  const info = useMemo(() => {
    if (isInput) {
      return {
        title: 'Compra de Insumos',
        renderComponent: (
          <Input
            ref={identificationComponentRef}
            updateTotalPrice={handleUpdateTotalPrice}
            callback={callbackFunctionIdentification}
          />
        ),
        description: 'Compra de insumo',
      };
    }
    return {
      title: 'Compra de Remessas',
      renderComponent: (
        <Remittance
          ref={identificationComponentRef}
          updateTotalPrice={handleUpdateTotalPrice}
          callback={callbackFunctionIdentification}
        />
      ),
      description: 'Compra de lotes',
    };
  }, [isInput]);

  const handleSubmitForms = () => {
    identificationComponentRef.current.handleSubmit();
    billComponentRef.current.handleSubmit();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSubmitForms();

    if (formsValid()) {
      const values = isInput
        ? { ...getValues(identificationRef), lots: [] }
        : { ...getValues(identificationRef), items: [] };

      const payload = {
        ...values,
        status: id ? dataLocation.status : 'concluída',
        date: id ? isValidDate(dataLocation.date) : new Date(),
        total: id ? dataLocation.total : getValues(billRef).value,
        bill: {
          ...getValues(billRef),
          id: id ? dataLocation?.bill?.id : null,
          type,
          description: info.description,
        },
      };

      postRequestPurchases(payload);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <S.Container>
          <S.Header>
            <S.HDialogTitle>Compra de Remessas</S.HDialogTitle>
            <S.HIconButton onClick={handleClose} aria-label="close">
              <CloseIcon sx={{ color: '#f00' }} />
            </S.HIconButton>
          </S.Header>

          <form onSubmit={handleSubmit}>
            <Box className={classes.root}>
              <CardContent sx={{ padding: 0 }}>
                <Grid container direction="column" gap={3}>
                  <Grid item>{info.renderComponent}</Grid>
                  <Grid item>
                    <Bill
                      ref={billComponentRef}
                      type={type}
                      description={info.description}
                      totalPrice={totalPrice}
                      disabledTotalValue
                      callback={callbackFunctionBill}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Box>

            <S.BoxButtons>
              <SingleButton
                variant="outlined"
                borderColor={green[800]}
                textColor={green[800]}
                hoverColor={green[100]}
                startIcon={<CloseIcon />}
                onClick={handleClose}
              >
                Cancelar
              </SingleButton>

              <SingleButton
                variant="contained"
                bgColor={green[800]}
                textColor="#fff"
                hoverColor={green[700]}
                startIcon={<SaveOutlinedIcon sx={{ color: 'white' }} />}
                type="submit"
              >
                Salvar
              </SingleButton>
            </S.BoxButtons>
          </form>
        </S.Container>
      )}
    </Dialog>
  );
}
